export default "__VITE_ASSET__345c006a__"